export var QUANTA_EXCHANGE_RATE = 0.2014;
